import { DOCUMENT } from '@angular/common';
import { inject, InjectionToken } from '@angular/core';

// Root-provided so it resolves everywhere (incl. TestBed) without app.config wiring;
// DOCUMENT.defaultView avoids referencing the window global directly.
export const WINDOW = new InjectionToken<Window>('WINDOW', {
  providedIn: 'root',
  factory: () => inject(DOCUMENT).defaultView as Window,
});
